'use client';
/**
 * Convert a date to a number
 * @param date - The date to convert
 * @returns The date as a number
 */
const toNumber = (date) => date instanceof Date ? date.getTime() : date;
/**
 * Convert a date to a Date
 * @param date - The date to convert
 * @returns The date as a Date
 */
const toDate = (date) => date instanceof Date ? date : new Date(date);

export { toDate, toNumber };
//# sourceMappingURL=converters.js.map
